import {useRouteError} from 'react-router-dom'

type RouteError = {
    statusText?: string,
    message?: string,
}

export function ErrorPage()
{
    const error = useRouteError() as RouteError | null;

    console.log(error)

    return (
        <div>
            <h1>An unexpected error occurred...</h1>
            <p>
                <i>{ error?.statusText ?? error?.message }</i>
            </p>
        </div>
    )
}
